import Commander from "../Commander";
import {getRandomInt} from "../../framework/src/helpers";
import * as PIXI from "pixi.js-legacy";
import {EASE, getTweenAsync} from "../../framework/src/modules/Tween";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";

class LineWinAnimations {
    constructor(commander) {
        this.commander = commander;
        this.audio = this.commander.audio;

        this.layer = {
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4]
        };

        this.soundNumber = 0;
        this.lastTextIndex = 0;
        this.lineCount = new Set();
    }

    run(lineWin) {
        this.lineCount.add(lineWin.line);
        let path = this.getNumbersPath(lineWin);
        this.numbers(lineWin, path.start, path.end);
        this.text(path.start, path.end);
    }

    getNumbersPath(lineWin) {
        let reels = this.commander.slots.getResultSymbols();
        return {
            start: reels[lineWin.position[0][0]*3+lineWin.position[0][1]],
            end: reels[lineWin.position[2][0]*3+lineWin.position[2][1]]
        };
    }

    async numbers(lineWin, start, mid) {
        let numberValue = this.commander.wallet.moneyToCredit(lineWin.win);

        let number = new PIXI.BitmapText(numberValue+"", {
            fontName: "font_win-export",
            fontSize: 70,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        });
        number.anchor.set(0.5,0.5);
        number.position.set(start.x, start.y);
        number.rotation = -25;
        this.setColor(number, start.name);
        this.layer.numbers.addChild(number);

        let path = [start.x, start.y, mid.x, mid.y+150, 640, 0];

        pixiSetTimeout(.95, async () => {
            await getTweenAsync(number.scale, {x:0, y:0}, 400, EASE.QUAD_I);
            Commander.removeTween(number);
            this.layer.numbers.removeChild(number);
        });
        await getTweenAsync(number, {guide:{ path: path}}, 1100, EASE.QUAD_I);
        this.audio.playTrack("win_Number_0"+this.getNumber(1,3));
        await getTweenAsync(number, {alpha: 0}, 200);
    }

    text(start, end) {
        let len = this.lineCount.size;
        if ((len === 2 || len === 5 || len === 10) && this.lastTextIndex < len) {
            let text;
            this.lastTextIndex = len;
            switch(len) {
                case 2:
                    text = new PIXI.Sprite(PIXI.Texture.from("multi_win.png"));
                    this.audio.playTrack("win_Combo_01");
                    break;
                case 5:
                    text = new PIXI.Sprite(PIXI.Texture.from("super_win.png"));
                    this.audio.playTrack("win_Combo_02");
                    break;
                case 10:
                    text = new PIXI.Sprite(PIXI.Texture.from("ultimate_win.png"));
                    this.audio.playTrack("win_Combo_03");
                    break;
                default:
                    return;

            }
            text.anchor.set(0.5,0.5);
            text.position.set(start.x, start.y);
            text.alpha = 1;
            text.scale.set(.69,.69);
            createjs.Tween.get(text)
                .to({x: end.x, y: end.y},1300)
                .to({alpha: 0, scale: 0}, 200)
                .call(() => {
                    Commander.removeTween(text);
                    this.layer.numbers.removeChild(text);
                });
            createjs.Tween.get(text.scale)
                .wait(950)
                .to({x: 0, y:0 }, 400, createjs.Ease.quadIn)
                .call(() => Commander.removeTween(text.scale));
            this.layer.numbers.addChild(text);
        }
    }

    setColor(text, name) {
        switch(name) {
            case "symbol_crystal_yellow":
            case "symbol_crystal_bar":
                this.commander.animColorFilter.hue(58-39, false);
                break;
            case "symbol_crystal_purple":
                this.commander.animColorFilter.hue(276-39, false);
                break;
            case "symbol_crystal_blue":
                this.commander.animColorFilter.hue(184-39, false);
                break;
            case "symbol_crystal_green":
                this.commander.animColorFilter.hue(85-39, false);
                break;
            case "symbol_crystal_seven":
                this.commander.animColorFilter.hue(356-39, false);
                break;
            case "symbol_crystal_orange":
                this.commander.animColorFilter.hue(0, false);
                break;
        }
    }

    getNumber(min, max) {
        let number;
        while(true) {
            number = getRandomInt(min,max);
            if (number !== this.soundNumber){
                return this.soundNumber = number;
            }
        }
    }

    cleanUp() {
        this.resetTextCounter();
        this.clearNumbers();
    }

    clearNumbers() {
        this.layer.numbers.removeChildren();
    }

    resetTextCounter() {
        this.lastTextIndex = 0;
        this.lineCount.clear();
    }
}
export default LineWinAnimations;
